<template>
  <div class="tradingAcc margin-general">
    <h2 class="">{{ $t("tradingAccounts.titleTable") }}</h2>
    <h2 class="title-margin">{{ $t("tradingAccounts.titleTable2") }}</h2>

    <SelectCustom
      class="selectItem"
      :options="tabs"
      v-model="selected"
    />

    <!-- <div class="buttonsContainer" ref="buttonsContainer">
      <button
        v-for="tab in tabs"
        :key="tab.name"
        class="buttonItem"
        :class="{ selected: selected === tab.value }"
        @click="selectTab(tab.value)"
      >
        {{ $t(tab.label) }}
      </button>
    </div> --> 

    <div class="card-content">
      <div class="cards-desktop">
        <div>
          <p style="color: white;" class="title-margin">Forex</p>
          <div class="items-content">
            <div v-for="row in categories.forex" :key="row.index" class="card">
              <div class="content">
                <p class="title body-4-bold">{{ $t(row.title) }}</p>
                <div class="line"></div>
                <div class="desc" :class="{ futures: selected === 'futures' }">
                  <div class="" v-for="item in row.items" :key="item.index">
                    <span class="material-symbols-outlined" translate="no">check</span>
                    <p class="caption-2">{{ $t(item.column1) }}</p>
                    <p class="caption-2" style="text-align: right">
                      {{ item.column2 === " " || item.column2 === "" ? " " : $t(item.column2) }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div>
          <p style="color: white;" class="title-margin">Stocks</p>
          <div class="items-content">
            <div v-for="row in categories.stocks" :key="row.index" class="card">
              <div class="content">
                <p class="title body-4-bold">{{ $t(row.title) }}</p>
                <div class="line"></div>
                <div class="desc" :class="{ futures: selected === 'futures' }">
                  <div class="" v-for="item in row.items" :key="item.index">
                    <span class="material-symbols-outlined" translate="no">check</span>
                    <p class="caption-2">{{ $t(item.column1) }}</p>
                    <p class="caption-2" style="text-align: right">
                      {{ item.column2 === " " || item.column2 === "" ? " " : $t(item.column2) }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- <div> descomentar cuando anadan futures
          <p style="color: white;" class="title-margin">Futures</p>
          <div class="items-content">
            <div v-for="row in categories.futures" :key="row.index" class="card">
              <div class="content">
                <p class="title body-4-bold">{{ $t(row.title) }}</p>
                <div class="line"></div>
                <div class="desc" :class="{ futures: selected === 'futures' }">
                  <div class="" v-for="item in row.items" :key="item.index">
                    <span class="material-symbols-outlined" translate="no">check</span>
                    <p class="caption-2">{{ $t(item.column1) }}</p>
                    <p class="caption-2" style="text-align: right">
                      {{ item.column2 === " " || item.column2 === "" ? " " : $t(item.column2) }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div> -->
      </div>
      <!-- <div class="disclaimer-cont">
        <a target="_blank" :href="getExternalUrl('/register/1/live-account')"
           rel="noopener noreferrer"><button class="second-button-small">
            {{ $t("tradingAccounts.btn-check") }}
          </button>
        </a>
        <p class="disclaimer caption-1">
          {{ $t("tradingAccounts.descritplarge") }}
        </p>
        <p v-if="selected === 'futures'" class="disclaimer caption-1">
          {{ $t("tradingAccounts.descritplarge1") }}
        </p>
        <p v-if="selected === 'futures'" class="disclaimer caption-1">
          {{ $t("tradingAccounts.descritplarge2") }}
        </p>
        <p v-if="selected === 'futures'" class="disclaimer caption-1">
          {{ $t("tradingAccounts.descritplarge3") }}
        </p>
      </div> -->
    </div>

    <div class="container-slide">
      <swiper
        :modules="modules"
        :spaceBetween="20"
        :slidesPerView="1"
        :navigation="true"
        class="swiperTrading"
      >
        <swiper-slide
          v-for="row in categories[selected]"
          :key="row.index"
          class="content-slide card"
        >
          <div class="content">
            <p class="title body-4-bold">{{ $t(row.title) }}</p>
            <div class="line"></div>
            <div class="desc" :class="{ futures: selected === 'futures' }">
              <div class="" v-for="item in row.items" :key="item.index">
                <span class="material-symbols-outlined" translate="no">check</span>
                <p class="caption-2">{{ $t(item.column1) }}</p>
                <p class="caption-2" style="text-align: right">
                  {{ item.column2 === " " || item.column2 === "" ? " " : $t(item.column2) }}
                </p>
              </div>
            </div>
          </div>
        </swiper-slide>
      </swiper>
      <!-- <a target="_blank" :href="getExternalUrl('/register/1/live-account')"
         rel="noopener noreferrer"><button class="second-button-small body-4-bold">
          {{ $t("tradingAccounts.btn-check") }}
        </button></a
      > -->
      <!-- <div class="disclaimer-cont">
        <p v-if="selected === 'stocks'" class="disclaimer caption-1">
          {{ $t("tradingAccounts.descritplarge") }}
        </p>
        <p v-if="selected === 'futures'" class="disclaimer caption-1">
          {{ $t("tradingAccounts.descritplarge1") }}
        </p>
        <p v-if="selected === 'futures'" class="disclaimer caption-1">
          {{ $t("tradingAccounts.descritplarge2") }}
        </p>
        <p v-if="selected === 'futures'" class="disclaimer caption-1">
          {{ $t("tradingAccounts.descritplarge3") }}
        </p>
      </div> -->
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from "vue";
import { Swiper, SwiperSlide } from "swiper/vue";
import { Autoplay, Pagination, Navigation } from "swiper/modules";
// import { useExternalUrl } from '@/composables/useExternalUrl';

import SelectCustom from "../utils/select/SelectCustom.vue";

// const { getExternalUrl } = useExternalUrl();

const selected = ref("forex");
const tabs = ref([
  { value: "forex", label: "tradingAccounts.categories1" },
  { value: "stocks", label: "tradingAccounts.categories2" },
  /* { value: "futures", label: "tradingAccounts.categories3" }, */
]);
const selectedButtonIndex = ref(0);
const borderStyle = ref({});
const categories = ref({
  forex: [
    {
      title: "tradingAccounts.ILC",
      items: [
        {
          column1: "tradingAccounts.spredfrom",
          column2: "tradingAccounts.result-1",
        },
        {
          column1: "tradingAccounts.result-16",
          column2: "",
        },
        {
          column1: "tradingAccounts.min-deposit",
          column2: "tradingAccounts.result-3",
        },
        {
          column1: "tradingAccounts.min-tarde",
          column2: "tradingAccounts.result-4",
        },
      ],
    },
    {
      title: "tradingAccounts.XLev",
      items: [
        /* { column1: "tradingAccounts.spreds-competitive", column2: "" }, */
        { column1: "tradingAccounts.no-commission", column2: "" },
        {
          column1: "tradingAccounts.no-min-deposit",
          column2: "",
        },
        {
          column1: "tradingAccounts.min-tarde",
          column2: "tradingAccounts.result-7",
        },
        /* {
          column1: "tradingAccounts.max-leverage",
          column2: "tradingAccounts.result-8",
        }, */
      ],
    },
    /* {
      title: "tradingAccounts.cTrader",
      items: [
        {
          column1: "tradingAccounts.spredfrom",
          column2: "tradingAccounts.result-1",
        },
        {
          column1: "tradingAccounts.commission",
          column2: "tradingAccounts.result-2",
        },
        {
          column1: "tradingAccounts.min-deposit",
          column2: "tradingAccounts.result-6",
        },
        {
          column1: "tradingAccounts.min-tarde",
          column2: "tradingAccounts.result-4",
        },
        {
          column1: "tradingAccounts.max-leverage",
          column2: "tradingAccounts.result-8",
        },
      ],
    }, */
  ],
  stocks: [
    /* {
      title: "tradingAccounts.Sterling*",
      items: [
        {
          column1: "tradingAccounts.commission",
          column2: "tradingAccounts.result-9",
        },
        {
          column1: "tradingAccounts.leverage",
          column2: "tradingAccounts.result-10",
        },
        {
          column1: "tradingAccounts.software-fee",
          column2: "tradingAccounts.result-11",
        },
      ],
    },
    {
      title: "tradingAccounts.Lightspeed",
      items: [
        {
          column1: "tradingAccounts.commission",
          column2: "tradingAccounts.result-9",
        },
        {
          column1: "tradingAccounts.leverage",
          column2: "tradingAccounts.result-10",
        },
        {
          column1: "tradingAccounts.software-fee",
          column2: "tradingAccounts.result-11",
        },
      ],
    }, */
    {
      title: "tradingAccounts.MT5**",
      items: [
        {
          column1: "tradingAccounts.commission",
          column2: "tradingAccounts.result-12",
        },
        /* {
          column1: "tradingAccounts.lev-deposit",
          column2: "tradingAccounts.result-9-5",
        }, */
        {
          column1: "tradingAccounts.software-fee",
          column2: "tradingAccounts.result-13",
        },
      ],
    },
    /* {
      title: "tradingAccounts.DAS",
      items: [
        {
          column1: "tradingAccounts.commission",
          column2: "tradingAccounts.result-9",
        },
        {
          column1: "tradingAccounts.leverage",
          column2: "tradingAccounts.result-10",
        },
        {
          column1: "tradingAccounts.software-fee",
          column2: "tradingAccounts.result-14",
        },
      ],
    },
    {
      title: "tradingAccounts.Takion***",
      items: [
        {
          column1: "tradingAccounts.commission",
          column2: "tradingAccounts.result-9",
        },
        {
          column1: "tradingAccounts.leverage",
          column2: "tradingAccounts.result-10",
        },
        {
          column1: "tradingAccounts.software-fee",
          column2: "tradingAccounts.result-15",
        },
      ],
    }, */
  ],
  /* futures: [
    {
      title: "tradingAccounts.MT5",
      items: [
        {
          column1: "tradingAccounts.list-large-1",
          column2: "",
        },
        { column1: "tradingAccounts.list-large-2", column2: "" },
      ],
    },
    {
      title: "tradingAccounts.CQG",
      items: [
        {
          column1: "tradingAccounts.list-large-5",
          column2: "",
        },
        { column1: "tradingAccounts.list-large-6", column2: "" },
        {
          column1: "tradingAccounts.list-large-7",
          column2: "",
        },
      ],
    },
  ], */
});

const modules = ref([Pagination, Autoplay, Navigation]);

const selectTab = (tabName) => {
  const newIndex = tabs.value.findIndex((tab) => tab.value === tabName);
  if (newIndex !== -1) {
    selected.value = tabName;
  }
  selectedButtonIndex.value = newIndex;
  updateBorderBottomStyle();
};

const initializeBorderBottomStyle = () => {
  const buttonsContainer = document.querySelector(".buttonsContainer");
  if (
    buttonsContainer &&
    buttonsContainer.children[selectedButtonIndex.value]
  ) {
    const button = buttonsContainer.children[selectedButtonIndex.value];
    borderStyle.value = {
      width: `${button.offsetWidth}px`,
      left: `${button.offsetLeft}px`,
    };
  }
};

const updateBorderBottomStyle = () => {
  const buttonsContainer = document.querySelector(".buttonsContainer");
  if (buttonsContainer && buttonsContainer.children[selectedButtonIndex.value]) {
    const button = buttonsContainer.children[selectedButtonIndex.value];
    borderStyle.value = {
      width: `${button.offsetWidth}px`,
      left: `${button.offsetLeft}px`,
    };
  }
};

onMounted(async () => {
  await nextTick();
  initializeBorderBottomStyle();
  selected.value = "forex";
});
</script>
